let market_prefix_2 = window.theme.marketPrefix;

if (market_prefix_2 === "main") {
    market_prefix_2 = "";
}

function updateYMALScrollbar() {
    document.querySelectorAll('.ymal-carousel').forEach((carousel) => {
        const carouselId = carousel.dataset.carouselId;
        const slides = Array.from(carousel.querySelectorAll('li.grid__item'))
            .filter(slide => window.getComputedStyle(slide).display !== "none");

        const track = document.querySelector(`.key-features-track-wrapper[data-carousel-id="ymal-carousel"] .carousel-track`);
        const rectangle = track.querySelector('.carousel-rectangle');

        rectangle.style.width = `${track.offsetWidth / slides.length}px`;

        const trackWidth = track.offsetWidth - rectangle.offsetWidth;

        // Function to update carousel scroll position based on rectangle position
        function updateCarouselScroll(rectangleX) {
            const scrollPercent = rectangleX / trackWidth;
            const scrollWidth = carousel.scrollWidth - slides.reduce((accum, slide) => accum + (window.getComputedStyle(slide).display !== "none" ? 0 : slide.offsetWidth), 0);
            const carouselWidth = carousel.offsetWidth;
            carousel.scrollLeft = scrollPercent * (scrollWidth - carouselWidth);
        }

        // Update rectangle position on carousel scroll
        carousel.addEventListener('scroll', () => {
            const scrollLeft = carousel.scrollLeft;
            const scrollWidth = carousel.scrollWidth - slides.reduce((accum, slide) => accum + (window.getComputedStyle(slide).display !== "none" ? 0 : slide.offsetWidth), 0);
            const carouselWidth = carousel.offsetWidth;
            const scrollPercent = scrollLeft / (scrollWidth - carouselWidth);

            rectangle.style.transform = `translateX(${scrollPercent * trackWidth}px)`;
        });

        // Dragging functionality
        let isDragging = false;
        let startX, startLeft;

        rectangle.addEventListener('mousedown', (e) => {
            isDragging = true;
            startX = e.clientX;
            startLeft = rectangle.offsetLeft;
            e.preventDefault();
        });

        document.addEventListener('mousemove', (e) => {
            if (!isDragging) return;
            const deltaX = e.clientX - startX;
            let newLeft = startLeft + deltaX;
            newLeft = Math.max(0, Math.min(newLeft, trackWidth));
            rectangle.style.transform = `translateX(${newLeft}px)`;
            updateCarouselScroll(newLeft);
        });

        document.addEventListener('mouseup', () => {
            isDragging = false;
        });
    });
}

let ymalGetProductsFrom = $('.product-recommendations').attr('data-get-additional-products-from');
let triedProducts = new Set();

function loadAdditionalYMALProducts(callback) {
    //console.log('Loading additional YMAL products...');
    fetch('/collections/' + ymalGetProductsFrom + '?view=ymal', { method: 'GET' })
    .then(result => result.text())
    .then(YMALProducts => {
        //console.log('Additional YMAL products loaded');
        callback(YMALProducts);
        updateYMALScrollbar();
    })
    .catch(errorMsg => { console.log('Error loading additional YMAL products:', errorMsg); });
}

function getAllYMALProducts(YMALProducts) {
    //console.log('Getting all YMAL products...');
    var $YMALProducts = $(YMALProducts);
    $YMALProducts.each(function() {
        var productHandle = $(this).data('product-handle');
        //console.log('Checking product handle:', productHandle);
        if ($('.ymal-carousel li[data-product-handle="' + productHandle + '"]').length === 0 && !triedProducts.has(productHandle)) {
            //console.log('Adding product handle:', productHandle);
            $(".ymal-carousel").append($(this));
            triedProducts.add(productHandle);
        }
    });
}

function getFirstYMALProduct(YMALProducts) {
    //console.log('Getting first YMAL product...');
    var $allProducts = $(YMALProducts); // Assuming YMALProducts is a jQuery object or HTML string
    var $selectedProduct = null;

    $allProducts.each(function() {
        if (!$(this).data('product-handle')) {
            return true; // Skip nodes without a product handle
        }
        var productHandle = $(this).data('product-handle');
        //console.log('Checking product:', this);
        //console.log('Product handle:', productHandle);
        if ($('.ymal-carousel li[data-product-handle="' + productHandle + '"]').length === 0 && !triedProducts.has(productHandle)) {
            //console.log('Selected product handle:', productHandle);
            $selectedProduct = $(this);
            return false; // Breaks the .each() loop
        }
    });

    if($selectedProduct) {
        //console.log('Appending selected product:', $selectedProduct.data('product-handle'));
        $(".ymal-carousel").append($selectedProduct);
        triedProducts.add($selectedProduct.data('product-handle'));
        $('.ymal-carousel .dynamically-added-product').addClass('shop-collection-title').append('<span class="reveal-top-ten">Shop Best Sellers</span>');
        if ($selectedProduct.attr('data-optical-products') === 'true') {
            $('.ymal-carousel .dynamically-added-product a').attr('href', '/collections/best-sellers-optical');
        } else {
            $('.ymal-carousel .dynamically-added-product a').attr('href', '/collections/best-sellers');
        }
    } else {
        //console.log('No valid product found, trying again...');
        // If no product was found, try loading additional products again.
        loadAdditionalYMALProducts(getFirstYMALProduct);
    }
}

var loadProductRecommendationsIntoSection = function () {
    var productRecommendationsSection = document.querySelector(".product-recommendations");
    if (productRecommendationsSection === null) {
        return;
    }

    var productId = productRecommendationsSection.dataset.productId;
    var productFamily = productRecommendationsSection.dataset.familyTitle;
    var limit = productRecommendationsSection.dataset.limit;

    var requestUrl = market_prefix_2 === "main" 
        ? "/recommendations/products?section_id=product-recommendations&limit=" + limit + "&product_id=" + productId
        : market_prefix_2 + "/recommendations/products?section_id=product-recommendations&limit=" + limit + "&product_id=" + productId;

    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function () {
        if (request.status >= 200 && request.status < 300) {
            setTimeout(function () {}, 1000);

            var container = document.createElement("div");
            container.innerHTML = request.response;
            productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

            var tooManyFamilyProducts = false;
            let hasLessThanSix = false;

            var productCount = $(".product-recommendations .grid__item").length;

            $(".product-recommendations .grid__item").each(function () {
                var $this = $(this);
                var familyTitleRelated = $this.attr("data-family-title");

                if (familyTitleRelated === productFamily || familyTitleRelated === "hide product") {
                    $this.remove();
                    if (familyTitleRelated.length > 5) {
                        tooManyFamilyProducts = true;
                    }
                }
            });

            if (productCount < 6) {
                hasLessThanSix = true;
                //console.log('Product count is less than 6');
                loadAdditionalYMALProducts(getAllYMALProducts);
            } else {
                loadAdditionalYMALProducts(getFirstYMALProduct);
            }

            if (tooManyFamilyProducts) {
                $(".hidden-extra-products .grid__item").each(function () {
                    var $this = $(this);
                    $this.appendTo(".product-recommendations .product-grid");
                });
            }

            setTimeout(function(){
                updateYMALScrollbar()
            }, 100);
        }
    };
    request.send();
};

document.addEventListener("DOMContentLoaded", function() {
    loadProductRecommendationsIntoSection();
});
